var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0147 25.8122C18.9117 25.9325 18.772 26 18.6265 26C18.4809 26 18.3413 25.9325 18.2383 25.8122L13.6606 20.462C13.5578 20.3416 13.5 20.1784 13.5 20.0083C13.5 19.8382 13.5578 19.675 13.6606 19.5546L18.2383 14.2043C18.2886 14.1413 18.3492 14.0907 18.4166 14.0556C18.484 14.0205 18.5567 14.0016 18.6305 14.0001C18.7042 13.9986 18.7775 14.0144 18.8459 14.0467C18.9143 14.079 18.9764 14.1271 19.0286 14.188C19.0808 14.249 19.1219 14.3216 19.1495 14.4016C19.1771 14.4815 19.1907 14.5671 19.1894 14.6534C19.1881 14.7396 19.172 14.8246 19.1419 14.9033C19.1119 14.9821 19.0686 15.053 19.0147 15.1117L15.3745 19.3663H25.9507C26.0964 19.3663 26.2361 19.4339 26.3391 19.5543C26.4421 19.6747 26.5 19.838 26.5 20.0083C26.5 20.1786 26.4421 20.3419 26.3391 20.4623C26.2361 20.5827 26.0964 20.6503 25.9507 20.6503H15.3745L19.0147 24.9048C19.1175 25.0252 19.1753 25.1884 19.1753 25.3585C19.1753 25.5287 19.1175 25.6919 19.0147 25.8122Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/BackArrowIcon.64d45ba1b13b7c401af30d68ad89659f.svg";
export { ForwardRef as ReactComponent };